import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";
import Iconify from '../components/iconify';
import EditVideoForm from '../components/EditVideoForm';
//styles scss 
import styles from "../styles/videoPage.module.scss";
// sections

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    height: '100%',
  },
}));



const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  // maxWidth: 1000,
  margin: 'auto',
  maxHeight: '100vh',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(2, 0, 0, 0),
}));

// ----------------------------------------------------------------------

export default function AddVideoPage() {
  const navigate = useNavigate();
  const mdUp = useResponsive('up', 'md');
  const handleBack = () => {
    navigate('/dashboard/videos')
  }
  return (
    <>
      <Helmet>
        <title> Edit Video | Video CMS</title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />
        <Button variant="contained" style={{ backgroundColor: "#00A651", maxHeight: "40px " }} onClick={handleBack}>Back</Button>
        <Container textAlign="center">
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              Update Video Details
            </Typography>
            <EditVideoForm></EditVideoForm>
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
